import React, { useState } from "react";
import {
  faDesktop,
  faMobile,
  faTablet,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
function Responsive({ activeMode, onChangeActiveMode }) {
  const [isSelectionActive, setSelectionActive] = useState(false);
  return (
    <>
      <div
        className="ml-1"
        onClick={(e) => {
          setSelectionActive(!isSelectionActive);
        }}
      >
        <FontAwesomeIcon
          className={`mx-2`}
          icon={
            activeMode === "desktop"
              ? faDesktop
              : activeMode === "tablet"
              ? faTablet
              : faMobile
          }
        />
      </div>
      <div
        className={`${
          isSelectionActive ? "visible" : "invisible"
        } absolute top-[-20px] gap-2 py-2 bg-white shadow-lg rounded flex-col flex z-50`}
      >
        <FontAwesomeIcon
          onClick={(e) => {
            onChangeActiveMode("desktop");
            setSelectionActive(!isSelectionActive);
          }}
          className={`mx-2`}
          icon={faDesktop}
        />
        <FontAwesomeIcon
          onClick={(e) => {
            onChangeActiveMode("tablet");
            setSelectionActive(!isSelectionActive);
          }}
          className="mx-2"
          icon={faTablet}
        />
        <FontAwesomeIcon
          onClick={(e) => {
            onChangeActiveMode("mobile");
            setSelectionActive(!isSelectionActive);
          }}
          className="mx-2"
          icon={faMobile}
        />
      </div>
    </>
  );
}

export default Responsive;
